import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { MachineService } from 'pages/standard-setup/machines/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(MachineService, DialogService, EventAggregator)
export class Machines {
    constructor(machineService, dialogService, ea) {
        this.ea = ea;
        this.machineService = machineService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'description' },
            { dataField: 'plants' },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('machines:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (machine) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.machineService.delete(machine.id);
                this.grid.refresh();
                toastr.success('Machine size was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.machineService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.machineService.editor, model: { id: data.id } });
    };
}